import React from 'react';
import ScrollIntoView from '../components/ScrollIntoView';

const About = () => {
  return (
    <ScrollIntoView>
      
      <div id="about-page">

        <section id="about-introduction">
          <h1>Bemutatkozás</h1>

          <div id="about-introduction-box">
            
            <div>
              <p>
                Cég neve: <b>Kisújszállási Városgazdálkodási Nonprofit Kft.</b>
                <br/>
                Alapító okirat kelte: <b>2003. November 13.</b>
                <br/>
                Székhelye: <b>Kisújszállás, Kossuth L. u. 74. szám</b>
              </p>

              <div className="about-introduction-list">
                <label>Fő tevékenységi köre:</label>
                <ul>
                  <li>Zöldterület-kezelés</li>
                </ul>
              </div>

              <div className="about-introduction-list">
                <label>Melléktevékenységek:</label>
                <ul>
                  <li>
                    parkosítás, fenntartás
                  </li>
                  <li>
                    önkormányzati bérlakások kezelése, fenntartása
                  </li>
                  <li>
                    társasházkezelés
                  </li>
                  <li>
                    magas- és mélyépítő munkák
                  </li>
                  <li>
                    szak- és szerelőipari tevékenység
                  </li>
                  <li>
                    településtisztasági tevékenység
                  </li>
                  <li>
                    piac- és köztisztasági telep üzemeltetés
                  </li>
                  <li>
                    bel- és csapadékelvezető rendszer üzemeltetés
                  </li>
                  <li>
                    temetkezési szolgáltatás, temetőüzemeltetés
                  </li>
                </ul>
              </div>

              <p>
                Ügyvezető: <b>Tóth Zoltán</b>
                <br/>
                Cégjegyzék szám: 16-09-007489
                <br/>
                Adószám: 13122186-2-16
                <br/>
                Statisztikai számjel: 13122186 3821 572 16
              </p>


            </div>

            <div id="about-introduction-img"></div>

          </div>

        </section>
        
        <section id="about-ltd">
          <h1>A Kft. bemutatása</h1>

          <h2>Előzmények</h2>

          <p>
            A Városgazdálkodási Vállalatot 1953. május 16-án alapította az akkori Kisújszállási Városi Tanács Végrehajtó Bizottsága, mint Kisújszállási Gőz- és Strandfürdő Vállalat, később Kisújszállási Ingatlankezelő Vállalat, majd Kisújszállási Kertészeti Vállalat lett. A vállalat típusa közüzemi vállalat, fő tevékenységi köre: köztisztasági szolgáltatás, parkosítás, állami bérlakások kezelése, fenntartása, magas- és mélyépítő munkák, szak- és szerelőipari tevékenység. 1981-ben kiegészül a településtisztasági tevékenységgel. 1986-ban a Kisújszállási Városi Tanács létesítette a Kisújszállási Városgazdálkodási Vállalatot. 1992-ben önkormányzati határozattal a vállalat új neve Városgazdálkodási Vállalat Kisújszállás lett, típusa: önkormányzati közüzemi vállalat, tevékenységi köre tovább bővült.
          </p>

          <h2>Jelenleg</h2>

          <p>
            A Kisújszállási Városgazdálkodási Kft. 2003. november 13-ai bejegyzéssel alakult, az 1953. május 16-án alapított Városgazdálkodási Vállalat Kisújszállás közüzemi vállalat (székhelye: 5310 Kisújszállás, Deák F. u. 10. szám, Cg.sz.: 16-01-000418, adószám: 10020573-2-16) jogutódjaként. A társaság határozatlan időre alakult. Alapító a Kisújszállás Város Önkormányzata (Kisújszállás, Szabadság tér 1.). A társaság létrehozásának célja, hogy a Kisújszállás várost kiszolgáló közüzemi szolgáltatási kötelezettségek teljesítésére a piaci viszonyoknak megfelelően hatékonyan teljesüljenek.
            <br/>
            A Kft. 2014. január 1-től törvényi kötelezettségek miatt nonprofit gazdasági társaságként működik.
          </p>
        </section>

        <section id="about-staff">
          <h1>Munkatársaink</h1>

          <div id="about-staff-cards">

            <div>

              <div className="staff-card">
                <b>Tóth Zoltán</b>
                <span>Ügyvezető</span>
                <a href="tel: +36 59/520-210">59/520-210</a>
              </div>

              <div className="staff-card">
                <b>Vékonyné Csikós Szilvia</b>
                <span>Gazdaságvezető</span>
                <a href="tel: +36 59/520-217">59/520-217</a>
              </div>

              <div className="staff-card">
                <b>Ponyokai Bálint</b>
                <span>Műszaki vezető</span>
                <a href="tel: +36 70/610-1644">70/610-1644</a>
              </div>

            </div>
            
            <div>

              <div className="staff-card">
                <b>Kása Attila</b>
                <span>Hulladékgazdálkodási vezető</span>
                <a href="tel: +36 59/520-213">59/520-213</a>
              </div>

              <div className="staff-card">
                <b>Máténé Gál Edina</b>
                <span>Ingatlanos ügyintéző</span>
                <a href="tel: +36 59/520-215">59/520-215</a>
                <a href="tel: +36 20/961-2444">20/961-2444</a>
              </div>

            </div>

            <div>

              <div className="staff-card">
                <b>Szabó Andrásné</b>
                <span>Temetkezési ügyintéző</span>
                <a href="tel: +36 59/520-700">59/520-700</a>
                <a href="tel: +36 30/214-3333">30/214-3333</a>
              </div>

              <div className="staff-card">
                <b>Vitáris Sándor</b>
                <span>Temetkezési üzletág vezető</span>
                <a href="tel: +36 20/212-5889">20/212-5889</a>
              </div>

            </div>

          </div>

        </section>

      </div>
    </ScrollIntoView>
  );
};

export default About;